import * as yup from 'yup';

export const schema = yup
  .object({
    des_receita: yup.string().trim().required(),
    des_formula: yup.string().trim().required(),
  })
  .required();
